import { STORES, idbDelete, idbGet, idbPut } from "./db"

const CORS_STATE_KEY = "imageCors"
// A bucket without CORS is probed again after this long.
const BLOCKED_RECHECK_MS = 6 * 60 * 60 * 1000

export const IMAGE_CORS = { UNKNOWN: "unknown", OK: "ok", BLOCKED: "blocked" }

export const IMAGE_FETCH = { OK: "ok", FAILED: "failed", BLOCKED: "blocked", OFFLINE: "offline" }

let lastWritten = null

export async function readImageCors() {
  const record = await idbGet(STORES.META, CORS_STATE_KEY)
  if (!record) return IMAGE_CORS.UNKNOWN
  if (record.state === IMAGE_CORS.BLOCKED && Date.now() - record.checkedAt > BLOCKED_RECHECK_MS) {
    return IMAGE_CORS.UNKNOWN
  }
  return record.state
}

export async function writeImageCors(state) {
  // An OK state only needs recording once per worker or page lifetime.
  if (state === IMAGE_CORS.OK && lastWritten === IMAGE_CORS.OK) return
  lastWritten = state
  await idbPut(STORES.META, { state, checkedAt: Date.now() }, CORS_STATE_KEY)
}

export async function resetImageCors() {
  lastWritten = null
  await idbDelete(STORES.META, CORS_STATE_KEY)
}

// Fetches in CORS mode; a throw that a no-cors retry survives means the bucket sends no CORS headers.
// Both skip the HTTP cache: a copy saved by a plain <img> load has no CORS headers and fails the check.
export async function fetchCorsImage(href) {
  try {
    const response = await fetch(href, { mode: "cors", credentials: "omit", cache: "reload" })
    return { outcome: response.ok ? IMAGE_FETCH.OK : IMAGE_FETCH.FAILED, response }
  } catch {
    try {
      const response = await fetch(href, { mode: "no-cors", credentials: "omit", cache: "reload" })
      return { outcome: IMAGE_FETCH.BLOCKED, response }
    } catch {
      return { outcome: IMAGE_FETCH.OFFLINE, response: null }
    }
  }
}
